import React from 'react';

// Styles & Assets
import styles from './AddColumn.module.css';

// Hooks

// Components
import Modal from '../Modal/Modal';

// Language
import { useTranslation } from 'react-i18next';

// Other
import moment from 'moment';

const AddColumn: React.FC<{
    addColumn: () => void,
    showDialog: boolean,
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ addColumn, showDialog, setShowModal }) => {

    const { t } = useTranslation();

    return (
        <>
            <button onClick={addColumn} className={`${styles.buttonAddCols} button`}>
                <span>{t('add_column')}</span><span style={{ fontSize: '1.2rem', fontFamily: 'MontserratRegular'  }}>+</span>
            </button>
            <Modal show={showDialog} setShowModal={setShowModal}>
                <div className={`${styles.dialog} dialog`}>
                    <p className={styles.errorText}>{t('already_registration') + ' ' + moment(new Date()).format('DD-MM-YYYY HH:00')}</p>
                    <button onClick={() => setShowModal(false)} className={`${styles.button} button`}>{t('close')}</button>
                </div>
            </Modal>
        </>
    );
};

export default AddColumn;